import * as React from 'react'
import { SVGProps } from 'react'
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 37 16"
    {...props}
  >
    <circle cx={16.962} cy={8} r={8} fill="currentColor" />
    <circle cx={6.192} cy={10.769} r={5.231} fill="currentColor" />
    <circle cx={30.808} cy={10.769} r={5.231} fill="currentColor" />
    <circle cx={24.654} cy={9.539} r={6.462} fill="currentColor" />
    <rect
      width={30.154}
      height={4.923}
      x={3.423}
      y={11.077}
      fill="currentColor"
      rx={2.462}
    />
  </svg>
)
export default SvgComponent
